import { Controller } from 'stimulus';
import Cookies from 'js-cookie';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
    static targets = ["button"];

    connect() {
        const subsidyId = this.buttonTarget.dataset.id.toString();
        let favoriteIds = Cookies.get('favorite_ids') ? JSON.parse(Cookies.get('favorite_ids')) : [];

        if (favoriteIds.includes(subsidyId)) {
            this.setFavoritedState();
        } else {
            this.setUnfavoritedState();
        }
    }

    toggleFavorite(event) {
        event.preventDefault();
        event.stopPropagation();

        const subsidyId = event.currentTarget.dataset.id.toString();
        let favoriteIds = Cookies.get('favorite_ids') ? JSON.parse(Cookies.get('favorite_ids')) : [];

        if (favoriteIds.includes(subsidyId)) {
            favoriteIds = favoriteIds.filter(id => id !== subsidyId);
            this.setUnfavoritedState();
            this.showNotification('お気に入りから削除しました', 'danger');
        } else {
            favoriteIds.push(subsidyId);
            this.setFavoritedState();
            this.showNotification('お気に入りに追加しました', 'info');
        }

        Cookies.set('favorite_ids', JSON.stringify(favoriteIds), { expires: 30 });
    }

    setFavoritedState() {
        const icon = this.buttonTarget.querySelector('i.fa-solid.fa-star');
        if(icon) {
            icon.classList.remove('far');
            icon.classList.add('fas');
        }

        const textSpan = this.buttonTarget.querySelector('.favorite-text');
        if (textSpan) {
            textSpan.textContent = 'お気に入り済み';
        }

        this.buttonTarget.classList.remove('btn-outline-favorite');
        this.buttonTarget.classList.add('btn-favorite');
    }

    setUnfavoritedState() {
        const icon = this.buttonTarget.querySelector('i.fa-solid.fa-star');
        if (icon) {
            icon.classList.remove('fas');
            icon.classList.add('far');
        }

        const textSpan = this.buttonTarget.querySelector('.favorite-text');
        if (textSpan) {
            textSpan.textContent = 'お気に入り追加';
        }

        this.buttonTarget.classList.add('btn-outline-favorite');
        this.buttonTarget.classList.remove('btn-favorite');
    }

    showNotification(message, type = 'info') {
        const toastElement = document.getElementById('liveToast');
        const toastFlexDiv = toastElement.querySelector('.d-flex');
        const toastBody = toastElement.querySelector('.toast-body');
        toastBody.textContent = message;

        // 既存の背景色クラスを削除
        toastFlexDiv.classList.remove('toast-info', 'toast-danger');

        if (type === 'danger') {
            toastFlexDiv.classList.add('toast-danger');
        } else {
            toastFlexDiv.classList.add('toast-info');
        }

        const toast = new bootstrap.Toast(toastElement);
        toast.show();
    }
}
